import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Agenzia } from 'src/app/models/agenzia';
import { AgenziaService } from 'src/app/services/agenzia.service';
import { BaseEditForm } from 'src/app/shared/baseEditForm';
import { findInRoute } from 'src/app/shared/utilities';


@Component({
  selector: 'agenzie-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class AgenzieFormComponent extends BaseEditForm implements OnInit {

  agenzia;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    private agenziaService: AgenziaService,
    private route: ActivatedRoute,
    @Optional() public dialogRef: MatDialogRef<AgenzieFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Agenzia,) {
    super();
    this.agenzia = data;
  }

  async ngOnInit() {

    const idAgenzia = findInRoute('idAgenzia', this.route);
    if (idAgenzia) {
      this.agenzia = await this.agenziaService.getOne(+idAgenzia, ['compagnie', 'comune']);
    }

    this.form = this.fb.group({
      nome: [this.agenzia?.nome, Validators.required],
      codice: [this.agenzia?.codice],
      via: [this.agenzia?.via],
      civico: [this.agenzia?.civico],
      comune: [this.agenzia?.comune],
      tel: [this.agenzia?.tel],
      fax: [this.agenzia?.fax],
      cell: [this.agenzia?.cell],
      email: [this.agenzia?.email],
      compagnia: [this.agenzia?.compagnia],
    });
  }


  async handleSuccessfulSubmit() {
    try {

      //edit existing agenzia or create new one
      if (this.agenzia?.id) {
        Object.assign(this.agenzia, this.form.value);
        await this.agenziaService.edit(this.agenzia);
      }
      else {
        let res = await this.agenziaService.create(this.form.value);
      }

    }
    catch (e) {
      this.toast.error('Impossibile salvare la agenzia');
      console.error(e);
    }

    this.toast.success(`Agenzia salvata`);
  }


}

